export default __webpack_public_path__ + "static/media/mail_icon_svg.244e0c26.svg";